import script from "./WReportPrint.vue?vue&type=script&setup=true&lang=ts"
export * from "./WReportPrint.vue?vue&type=script&setup=true&lang=ts"

import "./WReportPrint.vue?vue&type=style&index=0&id=c0a356b2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0a356b2"]])

export default __exports__